<div class="policy-overview-card" (click)="goToCase(annuity)">
  <div class="policy-overview-card__policy-information">
    <div class="policy-overview-card__case">
      <div>
        <div class="policy-overview-card__primary-label">Annuity For</div>
        <div class="insured">
          {{ annuity.annuitant.fullName }}
        </div>
      </div>
      <div class="policy-overview-card__arrow-icon">
        <img src="../../../../../common/img/icons/next-arrow.svg" />
      </div>
    </div>
    <div class="policy-overview-card__item">
      <div class="policy-overview-card__secondary-label">Initial Purchase Amount</div>
      <div class="policy-overview-card__value">
        {{ initialPurchaseAmount }}
      </div>
    </div>
    <div class="policy-overview-card__item">
      <div class="policy-overview-card__secondary-label">Annuity Type</div>
      <div class="policy-overview-card__value">
        {{ annuityDescription }}
      </div>
    </div>
    <div class="policy-overview-card__item" *ngIf="shouldShowPremium">
      <div class="policy-overview-card__secondary-label">Premium</div>
      <div class="policy-overview-card__value">
        {{ premium }}
      </div>
    </div>
    <div class="next-arrow-svg">
      <img src="../../../../../common/img/icons/next-arrow.svg" />
    </div>
  </div>
  <div class="policy-overview-card__status" *ngIf="cardStatusTitles.length > 0">
    <div class="policy-overview-card__status__icon">
      <img *ngIf="caseType === 'Application' && !isCancelled" src="../../../../../common/img/icons/pending.svg" />
      <img *ngIf="caseType === 'Policy' && !isCancelled" src="../../../../../common/img/icons/small_confirm.svg" />
      <img *ngIf="isCancelled" src="../../../../../common/img/icons/cancel.svg" />
    </div>
    <div class="policy-overview-card__message">
      <div class="policy-overview-card__title">
        <ng-container *ngFor="let title of cardStatusTitles">{{ title }} &nbsp;</ng-container>
      </div>
      <div class="policy-overview-card__subtitle">
        <ng-container *ngFor="let subTitle of cardStatusSubTitles">
          {{ subTitle }}
        </ng-container>
      </div>
    </div>
  </div>
</div>
